"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapUniversalLoanSourceToProduct = exports.UniversalLoanSource = void 0;
const Product_1 = require("../Product");
var UniversalLoanSource;
(function (UniversalLoanSource) {
    UniversalLoanSource["AG_LINE_OF_CREDIT"] = "AGRICULTURAL_LINE_OF_CREDIT";
    UniversalLoanSource["AG_PURCHASE_ACREAGE"] = "AGRICULTURAL_PURCHASE_ACREAGE";
    UniversalLoanSource["AG_PURCHASE_EQUIPMENT"] = "AGRICULTURAL_PURCHASE_EQUIPMENT";
    UniversalLoanSource["AG_REFINANCE_PROPERTY"] = "AGRICULTURAL_REFINANCE_PROPERTY";
    UniversalLoanSource["AUTO"] = "AUTO";
    UniversalLoanSource["BOOSTER"] = "BOOSTER";
    UniversalLoanSource["COMMERCIAL_BRIDGE_LOAN"] = "COMMERCIAL_BRIDGE_LOAN";
    UniversalLoanSource["COMMERCIAL_EQUIPMENT"] = "COMMERCIAL_EQUIPMENT";
    UniversalLoanSource["COMMERCIAL_PURCHASE"] = "COMMERCIAL_PURCHASE";
    UniversalLoanSource["COMMERCIAL_REFINANCE"] = "COMMERCIAL_REFINANCE";
    UniversalLoanSource["COMMERCIAL_RENEW"] = "COMMERCIAL_RENEW";
    UniversalLoanSource["COMMERCIAL_VEHICLE"] = "COMMERCIAL_VEHICLE";
    UniversalLoanSource["CREDIT"] = "CREDIT";
    UniversalLoanSource["FINANCIAL_STATEMENT"] = "FINANCIAL_STATEMENT";
    UniversalLoanSource["OTHER"] = "OTHER";
    UniversalLoanSource["OVERDRAFT_PROTECTION"] = "OVERDRAFT_PROTECTION";
    UniversalLoanSource["PERSONAL"] = "PERSONAL";
    UniversalLoanSource["REVERSE"] = "REVERSE";
    UniversalLoanSource["SB_LINE_OF_CREDIT"] = "SB_LINE_OF_CREDIT";
    UniversalLoanSource["SB_TERM"] = "SB_TERM";
})(UniversalLoanSource = exports.UniversalLoanSource || (exports.UniversalLoanSource = {}));
/**
 * This maps from loan source to product.  Returns undefined if the loan source does not map
 * to an existing product.
 *
 * @param {FormName} formName
 * @returns {UniversalLoanSource | undefined}
 */
const mapUniversalLoanSourceToProduct = (source) => {
    switch (source) {
        case UniversalLoanSource.AUTO:
            return Product_1.Product.AUTO_LOAN;
        case UniversalLoanSource.COMMERCIAL_BRIDGE_LOAN:
            return Product_1.Product.COMMERCIAL;
        case UniversalLoanSource.COMMERCIAL_EQUIPMENT:
            return Product_1.Product.COMMERCIAL;
        case UniversalLoanSource.COMMERCIAL_PURCHASE:
            return Product_1.Product.COMMERCIAL;
        case UniversalLoanSource.COMMERCIAL_REFINANCE:
            return Product_1.Product.COMMERCIAL;
        case UniversalLoanSource.COMMERCIAL_VEHICLE:
            return Product_1.Product.COMMERCIAL;
        case UniversalLoanSource.BOOSTER:
            return Product_1.Product.CREDIT_BOOSTER;
        case UniversalLoanSource.CREDIT:
            return Product_1.Product.CREDIT_CARD;
        case UniversalLoanSource.OTHER:
            return Product_1.Product.OTHER_VEHICLE;
        case UniversalLoanSource.OVERDRAFT_PROTECTION:
            return Product_1.Product.OVERDRAFT_PROTECTION;
        case UniversalLoanSource.PERSONAL:
            return Product_1.Product.PERSONAL_LOAN;
        case UniversalLoanSource.REVERSE:
            return Product_1.Product.REVERSE_MORTGAGE;
        case UniversalLoanSource.SB_LINE_OF_CREDIT:
            return Product_1.Product.SMALL_BUSINESS;
        case UniversalLoanSource.SB_TERM:
            return Product_1.Product.SMALL_BUSINESS;
        default:
            return undefined;
    }
};
exports.mapUniversalLoanSourceToProduct = mapUniversalLoanSourceToProduct;
